export default __webpack_public_path__ + "static/media/circle.ea38c121.png";